/*
 *******************************************************************************
 * 
 *  Filename:   ./constants/actionTypeProbabilities.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Probability Type Action Type constant definitions.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Monday, January 21, 2019 - 03:55:55 AM (CST)
 *
 *  Notes:
 *
 *
 *  Revisions:
 *      01/21/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

export const PROBABILITY_LIST_CONTAINER_LOADED = 'PROBABILITY_LIST_CONTAINER_LOADED';
export const PROBABILITY_LIST_CONTAINER_UNLOADED = 'PROBABILITY_LIST_CONTAINER_UNLOADED';
export const PROBABILITY_LIST_TABLE_LOADED = 'PROBABILITY_LIST_TABLE_LOADED';
export const PROBABILITY_LIST_TABLE_UNLOADED = 'PROBABILITY_LIST_TABLE_UNLOADED';

export const PROBABILITY_SELECT_ROW = 'PROBABILITY_SELECT_ROW';

export const PROBABILITY_ADD = 'PROBABILITY_ADD';
export const PROBABILITY_EDIT = 'PROBABILITY_EDIT';
export const PROBABILITY_DELETE = 'PROBABILITY_DELETE';
export const PROBABILITY_OPEN_WARNING = 'PROBABILITY_OPEN_WARNING';
export const PROBABILITY_CLOSE_WARNING = 'PROBABILITY_CLOSE_WARNING';

export const PROBABILITY_EDIT_CONTAINER_LOADED = 'PROBABILITY_EDIT_CONTAINER_LOADED';
export const PROBABILITY_EDIT_CONTAINER_UNLOADED = 'PROBABILITY_EDIT_CONTAINER_UNLOADED';
export const PROBABILITY_EDIT_FORM_LOADED = 'PROBABILITY_EDIT_FORM_LOADED';
export const PROBABILITY_EDIT_FORM_UNLOADED = 'PROBABILITY_EDIT_FORM_UNLOADED';

export const PROBABILITY_EDIT_DATA_LOAD = 'PROBABILITY_EDIT_DATA_LOAD';

export const PROBABILITY_EDIT_CONTAINER_SUBMIT = 'PROBABILITY_EDIT_CONTAINER_SUBMIT';
export const PROBABILITY_EDIT_CONTAINER_CANCEL = 'PROBABILITY_EDIT_CONTAINER_CANCEL';


// WEBPACK FOOTER //
// ./src/constants/actionTypeProbabilities.js